import { UsersService } from '@/services/users.service'
export default {
  fillRoleByUser ({ commit }, params) {
    return UsersService.fillPermissionByUser()
      .then(user => {
        if (user.message === 'Success') {
          commit('SET_PERMISSION_BY_USER', user.data.permissionCodes)
          localStorage.setItem('dataPermission', JSON.stringify(user.data.permissionCodes))
          return true
        }
        return false
      })
  },
  clear ({ commit }) {
    commit('CLEAR')
  }
}
